import React, { useReducer, useEffect, useState } from 'react';
import DataGrid, { Column, Lookup, Editing, Paging, Pager } from 'devextreme-react/data-grid';
import * as actions from '../../../actions/dashboard';
import dashboardReducer from '../../../reducers/dashboard';
import { GRID_CONFIG } from './config';
import { Toast } from 'devextreme-react/toast';

const initialState = { hseCommunicationData: [] }

export default ({ siteId, tierId, isEditable }) => {
    const [state, dispatch] = useReducer(dashboardReducer, initialState);
    let { hseCommunicationData } = state
    const [toastConfig, setToastConfig] = useState({ isVisible: false, type: 'info', message: '' });

    useEffect(() => {
        actions.fetchHSECommunicationData(dispatch, siteId, tierId);
    }, []);

    let gembaTypeList = ['Y', 'N'];

    const onRowUpdating = (e) => {
        let values = Object.values(e.newData);
        let keys = Object.keys(e.newData);
        let weekVal = keys[0].split('_')

        let data = {
            "SiteID": e.oldData.SiteID,
            "TierID": tierId,
            "HSECommunicationTask": e.oldData.HSECommunicationTask,
            "AttendedMonthName": weekVal[0],
            "AttendedMonthNo": new Date(Date.parse(weekVal[0] + " 1, 2012")).getMonth() + 1,
            "AttendedYear": parseInt(weekVal[1]),
            "IsAttended": values[0]
        }

        actions.updateHSECommunicationData(dispatch, data);
    }

    const cellRender = (data) => {
        let tpl = '';

        if (data.value === 'N')
            tpl = <div className="cell-red"><i className="fas fa-times" style={{ "fontSize": "1.5em" }}></i></div>
        if (data.value == null)
            tpl = <div className="cell-red"><i className="fas fa-times" style={{ "fontSize": "1.5em" }}></i></div>
        if (data.value !== 'N' && data.value != "" && data.value != null)
            tpl = <div className="cell-green"><i className="fas fa-check" style={{ "fontSize": "1.5em" }}></i></div>

        return tpl;
    }

    const getColDef = () => {
        let newDate = new Date();
        if (hseCommunicationData && hseCommunicationData[0]) {
            let items = Object.keys(hseCommunicationData[0]);
            let colDef = [];

            for (let i = 0; i < items.length; i++) {
                if (i < 2)
                    colDef.push(<Column key={i} dataField={items[i]} visible={false} />)

                else if (i == 2)
                    colDef.push(<Column key={i} dataField={items[i]} caption="HSECommunicationTask" allowEditing={false} />)

                else {
                    colDef.push(<Column key={i}
                        dataField={items[i]}
                        cssClass={(items[i] === `${newDate.toLocaleString('default', { month: 'long' })}_${newDate.getUTCFullYear()}`) ? "cell-highlight" : ""}
                        cellRender={cellRender}
                        allowEditing={(items[i] === `${newDate.toLocaleString('default', { month: 'long' })}_${newDate.getUTCFullYear()}`) ? true : false}
                    >
                        <Lookup
                            dataSource={gembaTypeList}
                        />
                    </Column>
                    )
                }
            }
            return colDef;
        }
        return [];
    }

    return (
        <>
            <DataGrid
                dataSource={hseCommunicationData}
                allowColumnReordering={true}
                showBorders={true}
                {...GRID_CONFIG}
                onRowUpdating={onRowUpdating}
                rowAlternationEnabled={false}
                repaintChangesOnly={true}
            >
                <Paging defaultPageSize={4} />
                <Pager
                    visible={true}
                    allowedPageSizes={[4, 8, 12]}
                    showPageSizeSelector={true}
                    showInfo={true}
                    showNavigationButtons={true}
                />

                {isEditable && <Editing mode="cell" allowUpdating={true} />}
                {getColDef()}
            </DataGrid>
            <Toast
                visible={toastConfig.isVisible}
                message={toastConfig.message}
                type={toastConfig.type}
                onHiding={() => setToastConfig({
                    ...toastConfig,
                    isVisible: false,
                })}
                displayTime={2000}
            />
        </>
    );
}